<template>
  <div>
    <el-dialog
      top="10vh"
      width="660px"
      center
      :title="`「${
        OrderStatusHistoryDialogObj.orderId
          ? OrderStatusHistoryDialogObj.orderId
          : '-'
      }」的订单状态历程 ( ${
        OrderStatusHistoryDialogObj.id ? OrderStatusHistoryDialogObj.id : '-'
      } ) `"
      :visible="OrderStatusHistoryDialogObj.visible"
      @close="HandleCancel"
    >
      <el-table
        border
        ref="table"
        v-loading="listLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
        :data="dataList"
      >
        <el-table-column label="操作时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作内容">
          <template slot-scope="scope">
            {{ scope.row.statusMessage }}
          </template>
        </el-table-column>
        <el-table-column label="用户名">
          <template slot-scope="scope">
            {{ scope.row.username }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { listOrderMenuHistory } from "@/api/order";

export default {
  mixins: [mainCommon],
  props: ["OrderStatusHistoryDialogObj"],
  data() {
    return {
      listLoading: false,
      dataList: [],
    };
  },
  watch: {
    OrderStatusHistoryDialogObj(row) {
      if (row.visible) {
        this.getList();
      }
    },
  },
  methods: {
    HandleCancel() {
      this.$emit("update:order-status-history-dialog-obj", { visible: false });
    },
    getList() {
      this.listLoading = true;
      listOrderMenuHistory({
        orderId: this.OrderStatusHistoryDialogObj.id,
        orderType: this.OrderStatusHistoryDialogObj.orderType,
      })
        .then((res) => {
          this.dataList = res.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/OrderStatusHistory.vue